import { apiFetch } from './client';

/**
 * phoneDefaults — default country code (dialing prefix) endpoints.
 *
 * `get` returns the EFFECTIVE prefix for the caller's tenant
 * (customer override → reseller override → platform setting → '+1').
 * super_admin / reseller_owner may pass customerId (the entered-customer
 * context) and/or resellerId to scope the resolution; other roles are
 * resolved from their own JWT tenant regardless.
 *
 * The platform-level setting (super_admin only) lives under
 * /platform-settings/phone-defaults, mirroring the CNAM/SMS settings shape.
 */

export interface PhoneDefaultsResult {
  /** Effective dialing prefix, e.g. '+1'. */
  prefix: string;
}

export interface PlatformPhoneDefaultsView {
  configured: boolean;
  /** Effective platform prefix — '+1' when nothing is configured. */
  country_code: string;
}

export type PlatformPhoneDefaultsBody =
  | { country_code: string }
  | { clear: true };

export const phoneDefaults = {
  get: (opts: { customerId?: string | null; resellerId?: string | null } = {}) => {
    const q = new URLSearchParams();
    if (opts.customerId) q.set('customer_id', opts.customerId);
    if (opts.resellerId) q.set('reseller_id', opts.resellerId);
    const qs = q.toString();
    return apiFetch<PhoneDefaultsResult>(`/api/phone-defaults${qs ? `?${qs}` : ''}`);
  },

  // ── Platform-level setting (super_admin) ──────────────────────────────────
  getPlatform: () =>
    apiFetch<PlatformPhoneDefaultsView>('/api/platform-settings/phone-defaults'),
  putPlatform: (body: PlatformPhoneDefaultsBody) =>
    apiFetch<{ ok: true }>('/api/platform-settings/phone-defaults', {
      method: 'PUT',
      body: JSON.stringify(body),
    }),
};
